import { OverviewTab } from '@/features/customers/components/Detail/Tabs/OverviewTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/customers/customer/$id/overview')({
  component: OverviewTab,
});
